'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'solar-system';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e02f';
var svgPathData = ['M46.8 108.3c2.3 6.4 6 12.4 11.2 17.6 7.3 7.3 16.3 11.7 25.8 13.4-55 80.9-46.6 192.1 25.1 263.8 59.5 59.5 146.2 75.4 220.2 47.7 4.6 13.6 12.3 26.3 23.1 37.1 1.3 1.3 2.6 2.5 4 3.8-93.2 39.6-205.1 21.4-281.2-54.7-89.5-89.5-98.9-228.8-28.2-328.7zM96 256c0-88.4 71.6-160 160-160 31.7 0 61.2 9.2 86.1 25.1-6.7 1.7-13 5.2-18.2 10.4-7.6 7.6-11.5 17.6-11.7 27.5-16.5-9.6-35.7-15.1-56.2-15.1-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112c0-20.5-5.5-39.7-15.1-56.2 10-.2 19.9-4.1 27.5-11.7 5.2-5.2 8.7-11.5 10.4-18.2 15.9 24.9 25.1 54.4 25.1 86.1 0 88.4-71.6 160-160 160S96 344.4 96 256zM155.9 20.3c93.2-39.6 205.1-21.3 281.2 54.7 89.5 89.5 98.9 228.8 28.2 328.7-2.3-6.4-6-12.4-11.2-17.6-7.3-7.3-16.3-11.7-25.8-13.4 55-80.9 46.6-192.1-25.1-263.8-59.5-59.5-146.2-75.4-220.2-47.7-4.6-13.6-12.3-26.3-23.1-37.1-1.3-1.3-2.6-2.5-4-3.7z', 'M58 125.9A48 48 0 1 0 125.9 58 48 48 0 1 0 58 125.9zM256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM454 454A48 48 0 1 0 386.1 386.1 48 48 0 1 0 454 454zM323.9 188.1a40 40 0 1 0 56.6-56.6 40 40 0 1 0 -56.6 56.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSolarSystem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;